var _a, _b;
import { __assign, __spreadArrays } from "tslib";
import { actionKey } from './constants';
import { uploadFile, uploadProgress, uploadSuccess, uploadFailure, } from './actions';
var defaultState = {
    fileUploads: [],
};
var actionHandlers = (_a = {},
    _a[uploadFile.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploads: __spreadArrays(state.fileUploads, [__assign({}, payload)]) }));
    },
    _a[uploadFailure.toString()] = function (state, _a) {
        var _b = _a.payload, fileId = _b.fileId, error = _b.error;
        return (__assign(__assign({}, state), { fileUploads: __spreadArrays(state.fileUploads).map(function (item) {
                return item.fileId === fileId ? __assign(__assign({}, item), { error: error }) : item;
            }) }));
    },
    _a[uploadProgress.toString()] = function (state, _a) {
        var _b = _a.payload, fileId = _b.fileId, progress = _b.progress;
        return (__assign(__assign({}, state), { fileUploads: __spreadArrays(state.fileUploads).map(function (item) {
                return item.fileId === fileId ? __assign(__assign({}, item), { progress: progress }) : item;
            }) }));
    },
    _a[uploadSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploads: state.fileUploads.filter(function (item) { return payload.fileId !== item.fileId; }) }));
    },
    _a);
var reducers = (_b = {},
    _b[actionKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map